// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"OrganisationsPage_sectionTitle__26Apo","overlay":"OrganisationsPage_overlay__2Q_48"};